import { MasonryPage } from 'components/masonry-page/masonry-page.component';
import { MASONRY } from 'common/constants';

export const FaqPage = () => (
  <MasonryPage
    screenName="FAQ"
    titleMessageId="STR_FAQ"
    rootNodeId={MASONRY.ROOT_NODE_ID_FAQ}
  />
);
